import { useEffect, useState } from 'react';
import { Logo } from '../components/Logo';
import { api } from '../api';

interface Props {
  token: string;
  onDone: () => void;
}

export function VerifyEmail({ token, onDone }: Props) {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.auth.verifyEmail(token)
      .then((res) => {
        setMessage(res.message);
        setStatus('success');
        setTimeout(onDone, 3000);
      })
      .catch((err: unknown) => {
        setMessage(err instanceof Error ? err.message : 'Verification failed');
        setStatus('error');
      });
  }, [token, onDone]);

  return (
    <div className="min-h-screen bg-brand-ink flex flex-col items-center justify-center px-4">
      <div className="mb-10">
        <Logo size="md" />
      </div>
      <div className="w-full max-w-sm bg-brand-paper rounded-xl p-8 shadow-xl text-center">
        {status === 'loading' && (
          <>
            <div className="w-8 h-8 rounded-full border-2 border-brand-green border-t-transparent animate-spin mx-auto mb-4" />
            <p className="text-sm text-gray-500">Verifying your email…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-4xl mb-4">✓</div>
            <p className="text-brand-green font-medium mb-2">Email verified!</p>
            <p className="text-sm text-gray-500">{message}</p>
            <p className="text-xs text-gray-400 mt-2">Redirecting to sign in…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-red-600 font-medium mb-2">Verification failed</p>
            <p className="text-sm text-gray-500 mb-4">{message}</p>
            <button
              onClick={onDone}
              className="text-sm text-brand-green hover:underline"
            >
              Back to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
